module.exports = __webpack_public_path__ + "static/img/Michael_Hurley_desktop.dd20cbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Michael_Hurley_desktop.jpg
// module id = srA6
// module chunks = 0